module.exports = __webpack_public_path__ + "img/proyecto5.5d3a4196.png";